__turbopack_context__.v({
  "articleAnchor": "index-module-scss-module__zbtDYa__articleAnchor",
});
